module.exports = __webpack_public_path__ + "img/white_logo_transparent.1c63f22c.svg";